import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
import { Guarantee } from './Guarantee';
export function ProofSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-6 md:py-10 px-6" data-id="element-215">
      <div className="max-w-4xl mx-auto" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-217">
          <div className="flex justify-center mb-4" data-id="element-218">
            <SparklesIcon className="w-12 h-12 text-gold" strokeWidth={1.5} data-id="element-219" />
          </div>

          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brown mb-6 text-center" data-id="element-220">
            Lo Que Cambia en 7 Días
          </h2>

          <div className="bg-gradient-to-br from-cream to-white rounded-3xl p-5 md:p-8 border-2 border-gold/20 shadow-lg" data-id="element-221">
            <p className="font-sans text-lg md:text-xl text-brown/90 leading-relaxed mb-3" data-id="element-222">
              No prometemos un positivo inmediato, pero prometemos un cambio de
              frecuencia.
            </p>

            <div className="space-y-2 mb-3" data-id="element-223">
              <p className="font-sans text-base md:text-lg text-brown/80 leading-relaxed" data-id="element-224">
                ✨ En la primera semana, el peso en tus hombros desaparece.
              </p>
              <p className="font-sans text-base md:text-lg text-brown/80 leading-relaxed" data-id="element-225">
                ✨ La relación con tu madre se suaviza.
              </p>
              <p className="font-sans text-base md:text-lg text-brown/80 leading-relaxed" data-id="element-226">
                ✨ El miedo constante se transforma en una certeza tranquila.
              </p>
            </div>

            <p className="font-sans text-lg md:text-xl text-brown font-semibold leading-relaxed text-center" data-id="element-227">
              Dejas de "buscar" un hijo con desesperación para empezar a
              "esperarlo" con orden.
            </p>

            <div className="mt-5 pt-4 border-t border-gold/20 text-center" data-id="element-228">
              <p className="font-sans text-base text-brown/70 mb-2" data-id="element-229">
                Accede hoy al sistema completo por solo:
              </p>
              <div className="flex flex-col items-center gap-2 mb-5" data-id="element-230">
                <div className="flex items-center gap-3" data-id="element-231">
                  <span className="font-serif text-2xl text-brown/40 line-through" data-id="element-232">
                    $27
                  </span>
                  <span className="font-sans text-base text-brown/70" data-id="element-233">USD</span>
                </div>
                <p className="font-sans text-base text-brown/80 font-medium" data-id="element-234">
                  Hoy solo
                </p>
                <div className="flex items-baseline gap-2" data-id="element-235">
                  <span className="font-serif text-4xl md:text-5xl font-bold text-rose whitespace-nowrap" data-id="element-236">
                    $14.00
                  </span>
                  <span className="font-sans text-lg text-brown/70 font-medium" data-id="element-237">
                    USD
                  </span>
                </div>
              </div>
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} onClick={() => {
              trackAddToCart();
              window.open('https://www.inerciacero.com/cart/42837827551335:1', '_blank');
            }} className="bg-rose text-white font-sans font-semibold text-lg px-12 py-5 rounded-full shadow-lg hover:bg-rose/90 transition-colors cursor-pointer" data-id="element-238">
                Quiero Sanar Mi Linaje y Recibir a Mi Hijo
              </motion.button>
              <p className="font-sans text-sm text-brown/60 mt-3" data-id="element-239">
                Acceso inmediato y discreto para comenzar esta misma noche.
              </p>
              <Guarantee data-id="element-240" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}